import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout";
import { useForm } from "react-hook-form";
import {
  BLACK_SPCL_CHARS,
  ORDER_NO_REGEX,
  REQUIRED_ERR_MSG,
} from "../Helper/Constants";
import GetSvgIcon from "../../images/svglist";
import { StyleComponent } from "../Utilities/Styles";
import CharteredTrackDetails from "./CharteredTrackDetails";
import { CallApiGet } from "../Helper/serviceApi";
import { Col, Row } from "react-bootstrap";
import { DLV_ACTION } from "../../ConfigConstants/ConfigConstants";

const initAlertConfig = {
  isSuccess: false,
  size: "",
  show: false,
  title: "",
  description: "",
};
const CharteredTrackingMain = () => {
  const [showSpoinner, setShowSpinner] = useState(false);
  const [alertConfig, setAlertConfig] = useState(initAlertConfig);
  const [trackData, setTrackData] = useState([]);
  const [orderNo, setOrderNo] = useState("");
  const [selOrder, setSelOrder] = useState(null);

  useEffect(() => {
    if (!!orderNo && orderNo.length > 0) {
      loadTrackData();
    }
  }, []);
  const openPopup = (bool, title, desc) => {
    setAlertConfig({
      isSuccess: bool,
      size: "md",
      show: true,
      title: title,
      description: desc,
    });
  };
  const closePopup = () => {
    setAlertConfig({
      isSuccess: false,
      size: "",
      show: false,
      title: "",
      description: "",
    });
  };
  const handleApiResponse = (resp) => {
    switch (resp.respCode) {
      case 500:
        openPopup(
          false,
          "ERROR",
          "Something went wrong. Please try after sometime!!"
        );
        break;
      case 99:
        openPopup(false, "ERROR", "Network Error!!");
        break;
      case 200:
        setTrackData([]);
        setSelOrder(null);
      case 0:
        break;
      default:
        openPopup(false, "ERROR", resp.respMessage);
        break;
    }
  };
  const loadTrackData = async (ordNo) => {
    setShowSpinner(true);
    const uri = `GetChTrackDetails?orderNo=${orderNo.split(",")}`;
    let resp = await CallApiGet(uri);

    if (
      resp?.respCode === 200 &&
      !!resp?.respData &&
      resp?.respData?.length > 0
    ) {
      setTrackData(resp.respData);
      setSelOrder(resp.respData[0]);
    } else {
      handleApiResponse(resp);
    }
    setShowSpinner(false);
  };
  const handleOnInput = (event) => {
    const orderNo = event.target.value;
    if (ORDER_NO_REGEX.test(orderNo)) {
      setOrderNo(orderNo);
    }
  };
  const renderTimeline = (item, outIndex, noOfStops) => {
    const itin = JSON.parse(item?.stopItin);
    const load = itin?.find((i) => i.deliveryAction === DLV_ACTION.LOAD);
    const unload = itin?.find((i) => i.deliveryAction === DLV_ACTION.UNLOAD);
    const eta = unload?.etaT?.split(" ") || load?.etaT?.split(" ");
    const etd = load?.etdT?.split(" ") || unload?.etdT?.split(" ");
    const ata = unload?.ataT?.split(" ") || load?.ataT?.split(" ");
    const atd = load?.atdT?.split(" ") || unload?.atdT?.split(" ");
    const isReached = !!unload?.ata || !!load?.atd;
    return (
      <>
        <li
          key={outIndex}
          className={`tl-item ${
            isReached ? "reached" : "planned"
            } margin-left-custom`}
        >
          <div className="timestamp left-70">
            <div className="text-nowrap">
              <span className="fw-bold theme-blue-txt text-uppercase">
                Arrival/Departure
              </span>
            </div>
            <div className="d-flex w-100">
              <span
                className="fw-bold text-secondary me-2 text-nowrap"
                title="ETA"
              >
                {!!eta ? (
                  <>
                    {eta[0]} <br /> {eta[1]}
                  </>
                ) : (
                  <>&#8212; </>
                )}
              </span>
              <span
                className="fw-bold text-secondary ms-4 text-nowrap"
                title="ETD"
              >
                {!!etd ? (
                  <>
                    {etd[0]} <br /> {etd[1]}
                  </>
                ) : (
                  <>&#8212; </>
                )}
              </span>
            </div>
            <div className="d-flex w-100 mt-2">
              <span
                className="fw-bold text-primary me-2 text-nowrap"
                title="ATA"
              >
                {!!ata ? (
                  <>
                    {ata[0]} <br /> {ata[1]}
                  </>
                ) : (
                  <>&#8212; </>
                )}
              </span>
              <span
                className="fw-bold text-primary ms-4 text-nowrap"
                title="ATD"
              >
                {!!atd ? (
                  <>
                    {atd[0]} <br /> {atd[1]}
                  </>
                ) : (
                  <>&#8212; </>
                )}
              </span>
            </div>
          </div>
          <div className="float-start">
            <div className="font-12 text-secondary w-100">
              {`${item?.stopAddress}, ${item?.stopCity}, ${item?.stopState}, ${item?.stopPostcode}`}
            </div>
          </div>
          {outIndex < noOfStops - 1 && (
            <>
              <div className="position-absolute start-0 d-flex v-place font-12 fw-bold">
                <div className="mx-3 theme-blue-txt align-self-center text-primary text-nowrap">
                  {GetSvgIcon("BiCursor")}{" "}
                  {load?.routeCode || unload?.routeCode || <>&#8212;</>}
                </div>
              </div>
              <br />
              <div className="position-absolute start-0 d-flex v-place font-12 fw-bold">
                <div className="mx-3 theme-blue-txt align-self-center text-primary text-nowrap">
                  {GetSvgIcon("IconTruck")}{" "}
                  {load?.vhclNo || unload?.vhclNo || <>&#8212;</>}
                </div>
              </div>
              <br />
              <div className="position-absolute start-0 d-flex v-place font-12 fw-bold">
                <div className="mx-3 theme-blue-txt align-self-center text-nowrap">
                  {GetSvgIcon("IconSystemconfig")}{" "}
                  {(load?.driver1Id && load?.driver1) ||
                    (unload?.driver1Id && unload?.driver1) || <>&#8212;</>}
                </div>
                <div className="mx-3 theme-blue-txt align-self-center text-secondary text-nowrap">
                  {GetSvgIcon("IconSystemconfig")}{" "}
                  {(load?.driver2Id && load?.driver2) ||
                    (unload?.driver2Id && unload?.driver2) || <>&#8212;</>}
                </div>
              </div>
            </>
          )}
        </li>
      </>
    );
  };
  return (
    <Layout
      spinnershow={showSpoinner}
      alertConfig={alertConfig}
      hideAlert={closePopup}
    >
      <div className="clearfix border-bottom">
        <div className="float-start">
          <div className="section-title mt-1">Track Chartered Order</div>
        </div>
      </div>
      <div className="w-50 m-auto">
        <div className="input-group my-3">
          <input
            type="text"
            className="form-control"
            style={StyleComponent.searchCapsule}
            placeholder="Enter Order numbers"
            value={orderNo}
            onChange={handleOnInput}
          />
          <button
            className="btn btn-outline-secondary theme-violet rounded-1s input-group-text"
            type="button"
            id="button-addon2"
            title="Track"
            onClick={() => loadTrackData()}
          // disabled={!watchOrd}
          >
            Search Chartered Order {GetSvgIcon("ArrowRight")}
          </button>
        </div>
      </div>
      {trackData?.length > 0 && (
        <Row>
          <Col>
            <CharteredTrackDetails
              trackData={trackData}
              selOrder={selOrder}
              setSelOrder={setSelOrder}
            />
          </Col>
          <Col md={6}>
            <div className="shadow border border-1 rounded-3 end-0 vh-100">
              <div className=" pb-5 track-shipment-bg">
                <div className="history-tl-container">
                  <ul className="tl">
                    {selOrder?.itinearyList?.map((item, index) =>
                      renderTimeline(
                        item,
                        index,
                        selOrder?.itinearyList?.length
                      )
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      )}
    </Layout>
  );
};

export default CharteredTrackingMain;
